import { render, staticRenderFns } from "./Robos.vue?vue&type=template&id=44cbbf80&"
import script from "./Robos.vue?vue&type=script&lang=js&"
export * from "./Robos.vue?vue&type=script&lang=js&"
import style0 from "./Robos.vue?vue&type=style&index=0&id=44cbbf80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports